<div class="w-full flex flex-col gap-16 md:gap-28">
  <!-- Sección de la cabecera. -->
  <section class="mt-16 md:mt-28 flex flex-col gap-4">
    <h1 class="text-4xl font-medium md:text-5xl">Configuración general</h1>
    <p class="text-lg md:text-xl">
      Consulta y actualiza las configuraciones generales.
    </p>
  </section>

  <!-- Sección del cuerpo. -->
  <section class="w-full flex flex-col gap-24 xl:w-2/4">
    @if (loadingConfigurations) {
    <div class="flex flex-col gap-5">
      <div class="h-12 bg-gray-200 cursor-wait animate-pulse"></div>
      <div class="h-12 bg-gray-200 cursor-wait animate-pulse"></div>
      <div class="h-12 bg-gray-200 cursor-wait animate-pulse"></div>
      <div class="h-12 bg-gray-200 cursor-wait animate-pulse"></div>
      <div class="w-64 h-10 bg-gray-200 cursor-wait animate-pulse"></div>
    </div>
    <div class="flex flex-col gap-5">
      <div class="h-12 bg-gray-200 cursor-wait animate-pulse"></div>
      <div class="h-12 bg-gray-200 cursor-wait animate-pulse"></div>
      <div class="w-64 h-10 bg-gray-200 cursor-wait animate-pulse"></div>
    </div>
    <div class="flex flex-col gap-5">
      <div class="h-12 bg-gray-200 cursor-wait animate-pulse"></div>
      <div class="w-64 h-10 bg-gray-200 cursor-wait animate-pulse"></div>
    </div>
    } @else {
    <div class="flex flex-col gap-10">
      <h2 class="text-md font-medium uppercase text-[#005cbb]">
        Correo electrónico
      </h2>

      <!-- Formulario de la configuración del correo electrónico. -->
      <form
        class="flex flex-col"
        [formGroup]="formEmail"
        (ngSubmit)="saveEmailConfigurations()"
      >
        <mat-form-field>
          <mat-label>Host</mat-label>
          <input
            type="text"
            name="host"
            formControlName="host"
            placeholder="mail.ejemplo.com"
            matInput
          />
        </mat-form-field>
        <mat-form-field>
          <mat-label>Puerto</mat-label>
          <input
            type="number"
            name="port"
            formControlName="port"
            placeholder="465"
            matInput
          />
        </mat-form-field>
        <mat-form-field>
          <mat-label>Nombre</mat-label>
          <input
            type="text"
            name="displayName"
            formControlName="displayName"
            matInput
          />
        </mat-form-field>
        <mat-form-field>
          <mat-label>Usuario</mat-label>
          <input
            type="email"
            name="user"
            formControlName="user"
            placeholder="ejemplo@ejemplo.com"
            matInput
          />
        </mat-form-field>
        <mat-slide-toggle formControlName="secure">
          <span class="text-base pl-2">¿Seguridad?</span>
        </mat-slide-toggle>

        <!-- Errores al guardar las configuraciones del correo electrónico. -->
        @if (errorsOnSaveEmailConfigurations.length > 0) {
        <div class="flex flex-col gap-2 text-center lg:text-start mt-5">
          @for (error of errorsOnSaveEmailConfigurations; track error) {
          <span class="text-sm text-red-500">{{ error }}</span>
          }
        </div>
        }

        <button
          type="submit"
          mat-flat-button
          class="lg:w-64 mt-10"
          [disabled]="formEmail.invalid || loadingSaveEmailConfigurations"
        >
          @if (loadingSaveEmailConfigurations) {
          <mat-spinner diameter="18"></mat-spinner>
          } @else {
          <span class="text-base">Guardar</span>
          }
        </button>
      </form>

      <!-- Formulario de la contraseña de la configuración del correo electrónico. -->
      <form
        class="flex flex-col"
        [formGroup]="formEmailPassword"
        (ngSubmit)="saveEmailPasswordConfiguration()"
      >
        <mat-form-field>
          <mat-label>Contraseña</mat-label>
          <input
            matInput
            [type]="emailPasswordPasswordHide ? 'password' : 'text'"
            name="password"
            formControlName="password"
          />
          @if (formEmailPasswordPassword?.value) {
          <button
            mat-icon-button
            matSuffix
            type="button"
            (click)="emailPasswordPasswordHide = !emailPasswordPasswordHide"
            [attr.aria-label]="'Hide password'"
            [attr.aria-pressed]="emailPasswordPasswordHide"
          >
            <mat-icon>{{
              emailPasswordPasswordHide ? "visibility_off" : "visibility"
            }}</mat-icon>
          </button>
          }
        </mat-form-field>
        <mat-form-field>
          <mat-label>Repetir contraseña</mat-label>
          <input
            matInput
            [type]="emailPasswordConfirmPasswordHide ? 'password' : 'text'"
            name="confirmPassword"
            formControlName="confirmPassword"
          />
          @if (formEmailPasswordConfirmPassword?.value) {
          <button
            mat-icon-button
            matSuffix
            type="button"
            (click)="
              emailPasswordConfirmPasswordHide =
                !emailPasswordConfirmPasswordHide
            "
            [attr.aria-label]="'Hide password'"
            [attr.aria-pressed]="emailPasswordConfirmPasswordHide"
          >
            <mat-icon>{{
              emailPasswordConfirmPasswordHide ? "visibility_off" : "visibility"
            }}</mat-icon>
          </button>
          }
        </mat-form-field>

        <!-- Errores al guardar la contraseña de la configuración del correo electrónico. -->
        @if (errorsOnSaveEmailPasswordConfiguration.length > 0) {
        <div class="flex flex-col gap-2 text-center lg:text-start mt-5">
          @for (error of errorsOnSaveEmailPasswordConfiguration; track error) {
          <span class="text-sm text-red-500">{{ error }}</span>
          }
        </div>
        }

        <button
          type="submit"
          mat-flat-button
          class="lg:w-64 mt-10"
          [disabled]="
            formEmailPassword.invalid || loadingSaveEmailPasswordConfiguration
          "
        >
          @if (loadingSaveEmailPasswordConfiguration) {
          <mat-spinner diameter="18"></mat-spinner>
          } @else {
          <span class="text-base">Cambiar contraseña</span>
          }
        </button>
      </form>
    </div>

    <!-- Sección de la activación -->
    <div class="flex flex-col gap-10">
      <h2 class="text-md font-medium uppercase text-[#005cbb]">Activación</h2>

      <!-- Formulario de la configuración de la activación. -->
      <form
        class="flex flex-col"
        [formGroup]="formActivation"
        (ngSubmit)="saveActivationConfigurations()"
      >
        <mat-form-field>
          <mat-label>Correo electrónico</mat-label>
          <input
            type="email"
            name="confirmationEmail"
            formControlName="confirmationEmail"
            placeholder="ejemplo@ejemplo.com"
            matInput
          />
        </mat-form-field>

        <!-- Errores al guardar las configuraciones de l’activación. -->
        @if (errorsOnSaveActivationConfigurations.length > 0) {
        <div class="flex flex-col gap-2 text-center lg:text-start mt-5">
          @for (error of errorsOnSaveActivationConfigurations; track error) {
          <span class="text-sm text-red-500">{{ error }}</span>
          }
        </div>
        }

        <button
          type="submit"
          mat-flat-button
          class="lg:w-64 mt-10"
          [disabled]="
            formActivation.invalid || loadingSaveActivationConfigurations
          "
        >
          @if (loadingSaveActivationConfigurations) {
          <mat-spinner diameter="18"></mat-spinner>
          } @else {
          <span class="text-base">Guardar</span>
          }
        </button>
      </form>
    </div>
    }
  </section>
</div>
